<template>
  <ValidationObserver tag="div" v-slot="{ passes }">
    <form
      @submit.prevent="passes(formSubmit)"
      class="currency_validate"
      method="post"
      :class="flex && 'row'"
    >
      <div class="form-group">
        <div class="row">
          <div class="col-xl-12 col-lg-12">
            <ValidationProvider
              tag="div"
              rules="required"
              v-slot="{ errors }"
              name="currency"
              class="form-group"
              :class="flex && 'col-xl-4 mb-0'"
            >
              <label class="mr-sm-2">Currency</label>
              <div class="mb-3">
                <!-- <div class="input-group-prepend">
                  <label class="input-group-text"
                    ><i class="cc BTC-alt"></i
                  ></label>
                </div> -->
                <select
                  v-model="currency"
                  name="currency"
                  class="form-control"
                  @change="
                    crypto_input_placeholder = currency
                      ? `fee : ${formatNumber(
                          mul(sub(1, currency.exchange_rate), 100),
                          1
                        )} %`
                      : ''
                  "
                >
                  <option value="">Select</option>
                  <option
                    :value="item"
                    v-for="(item, index) in targetPairs"
                    :key="index"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <label class="error" for="currency">{{ errors[0] }}</label>
              </div>
            </ValidationProvider>
          </div>
          <!-- <div class="col-xl-6 col-lg-6">
            <ValidationProvider
              tag="div"
              rules="required"
              v-slot="{ errors }"
              name="method"
              class="form-group"
              :class="flex && 'col-xl-4 mb-0'"
            >
              <label class="mr-sm-2">Payment </label>

              <div class="mb-3" v-if="useBalance">
                <select
                  :disabled="!currency"
                  class="form-control"
                  v-model="selectSymbolItem"
                  name="method"
                  v-if="useBalance"
                  placeholder="Select"
                  @change="
                    currency_input_placeholder = selectSymbolItem
                      ? `Max: ${formatNumber(selectSymbolItem.available, 4)}`
                      : ''
                  "
                >
                  <option
                    :value="item"
                    v-for="(item, index) in basePairs"
                    :key="index"
                    :v-if="item.symbol != currency.symbol"
                  >
                    {{ item.base_symbol }}
                  </option>
                </select>

                <label class="error" for="method">{{ errors[0] }}</label>
              </div>

              <div class="input-group mb-3" v-if="!useBalance">
                <div class="input-group-prepend">
                  <label class="input-group-text"
                    ><i :class="`fa fa-credit-card`"></i>
                  </label>
                </div>
                <select
                  class="form-control"
                  v-model="selectCardItem"
                  name="method"
                  v-if="!useBalance"
                >
                  <option value="">Select</option>
                  <option
                    :value="item"
                    v-for="(item, index) in data"
                    :key="index"
                  >
                    {{ item.cardName }} {{ item.typeName }}
                    {{ item.account_no }}
                  </option>
                </select>
                <label class="error" for="method">{{ errors[0] }}</label>
              </div>
            </ValidationProvider>
          </div> -->
        </div>
      </div>

      <div class="form-group" :class="flex && 'col-xl-4 mb-0'">
        <div class="form-group">
          <div class="row">
            <div class="col-xl-6 col-lg-6">
              <label class="mr-sm-2">Buy Count</label>

              <input
                type="text"
                :disabled="!currency ? true : false"
                class="form-control"
                :placeholder="currency_input_placeholder"
                v-model="currency_amount"
              />
            </div>
            <div class="col-xl-6 col-lg-6">
              <label class="mr-sm-2"
                >Estimated receipt
                <span v-if="price15s">( {{ price15s.price }} )</span></label
              >

              <input
                type="text"
                :disabled="isRightForm"
                class="form-control"
                :placeholder="crypto_input_placeholder"
                v-model="usd_amount"
              />
            </div>
          </div>
        </div>
        <label class="mr-sm-2"></label>
        <!-- <ValidationProvider tag="div" rules="required" v-slot="{ errors }">
          <div class="input-group">
            <label class="error" for="method">{{ errors[0] }}</label>
          </div>
        </ValidationProvider> -->
        <!-- <div class="d-flex justify-content-between mt-3" v-if="!flex">
          <p class="mb-0">Monthly Limit</p>
          <h6 class="mb-0">$49750 remaining</h6>
        </div> -->
      </div>
      <!-- <div class="col-12" v-if="flex">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="mb-0">$49750 remaining</h6>
          <button type="submit" name="submit" class="btn btn-success px-5 mt-2">
            Exchange Now
          </button>
        </div>
      </div> -->
      <button
        :disabled="isRightForm"
        v-if="!flex"
        type="submit"
        name="submit"
        class="btn btn-success btn-block"
      >
        Exchange Now
      </button>
    </form>
  </ValidationObserver>
</template>

<script scoped>
// import "./validation/Intro";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { enable_card_list } from "../../../plugins/api/user_bank_acc";
import { common_tras_pairs, com_15s_price } from "../../../plugins/api/common";
import { amountinfo } from "../../../plugins/api/amount";
import {
  mul,
  div,
  sub,
  formatNumber,
  debounce,
} from "../../../plugins/operation";
import { createOrder } from "../../../plugins/api/order";

export default {
  name: "CurrencyForm",
  methods: {
    mul(num1, num2) {
      return mul(num1, num2);
    },
    sub(num1, num2) {
      return sub(num1, num2);
    },
    formatNumber(num1, length, sp) {
      return formatNumber(num1, length, sp);
    },
    legal_change() {
      if (this.currency) {
        this.usd_amount = mul(
          this.currency_amount,
          this.currency.exchange_rate
        );
        // formatNumber(
        //   mul(this.currency_amount, this.currency.exchange_rate),
        //   this.currency.fixed,
        //   ""
        // );
      }
    },
    usd_change() {
      if (this.currency) {
        this.currency_amount = div(
          this.usd_amount,
          this.currency.exchange_rate
        );
        //  formatNumber(
        //   div(this.usd_amount, this.currency.exchange_rate),
        //   this.currency.fixed,
        //   ""
        // );
      }
    },
    formSubmit() {
      let formInfo = {
        useBalance: this.useBalance,
        ex_currency: this.currency,
        ex_amount: this.usd_amount,
        // payCard: this.selectCardItem,
        sourceSymbol: this.selectSymbolItem,
        sourceAmount: this.currency_amount,
        side: "BUY",
      };

      if (
        formInfo.ex_currency &&
        formInfo.ex_amount &&
        // formInfo.sourceSymbol &&
        this.currency.name
      ) {
        createOrder(formInfo).then((res) => {
          if (res.code == 0) {
            this.usd_amount = "";
            this.currency_amount = "";
            this.$Message.success(res.msg);

            // this.$router.push(`/order/detail/${res.data.id}`);
            this.$router.push(`/order/list`);
            // this.$alert(
            //   "When the supplement is complete, the OTC919 verification review will be ready for use.",
            //   "Props",
            //   {
            //     confirmButtonText: "Enter",
            //     type: "success",
            //     showClose: false,
            //     closeOnClickModal: false,
            //     callback: (action) => {
            //     },
            //   }
            // );
            // res.data.id
          } else {
            this.$Message.error(res.msg);
          }
        });
      } else {
        this.$Message.error("Parameter error");
      }
    },
    initTransPairs() {
      common_tras_pairs({ side: "BUY" }).then((res) => {
        if (res.code == 0) {
          this.transPairs = res.data.pair;
          var obj = {};
          let arr = res.data.pair;
          this.targetPairs = arr;
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    getdata() {
      enable_card_list().then((res) => {
        if (res.code == 0) {
          res.data.forEach((item) => {
            item.typeName = "Credit Card";
            item.cardName = "";
            switch (item.account_type) {
              case "mastercard":
                item.cardName = "Master";
                break;
              case "visa":
                item.cardName = "Visa";
                break;
              case "amex":
                item.cardName = "American Express";
                break;
              case "unionpay":
                item.cardName = "Union";
                item.typeName = "Debit Card";
                break;
            }
            return item;
          });
          // console.log(cardlist);
          this.data = res.data;
        }
      });
    },
    freshPrice: debounce(({ vm, __name, __side, __amount }) => {
      com_15s_price(__name, __side, __amount).then((res) => {
        if (res.client_rfq_id) {
          vm.price15s = res;
          vm.currency.exchange_rate = res.price;
          vm.isRightForm = false;
          vm.legal_change();
        } else {
          vm.$Message.warning("The number of transactions is limited");
          vm.isRightForm = true;
        }
      });
    }, 1000),
  },
  created() {
    this.balances = this.$store.getters.balanceList;
    if (this.balances.length == 0) {
      amountinfo().then((data) => {
        this.balances = data;
      });
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    flex: Boolean,
  },
  watch: {
    usd_amount: function (val, old) {
      if (val != old) {
        // this.freshPrice();
      }
    },
    currency_amount: function (val, old) {
      if (val != old) {
        this.freshPrice({
          vm: this,
          __name: this.currency.name,
          __side: "buy",
          __amount: this.currency_amount,
        });
      }
    },
  },
  data() {
    return {
      // erros: {},
      isRightForm: true,
      price15s: null,
      basePairs: null,
      useBalance: true,
      currency: "",
      selectCardItem: "",
      selectSymbolItem: "",
      currency_amount: "",
      usd_amount: "",
      submitted: false,
      data: [],
      transPairs: [],
      targetPairs: [],
      balances: [],
      currency_input_placeholder: "Input Quantity<$50,000",
      crypto_input_placeholder: "USD",
    };
  },
  mounted() {
    this.getdata();
    this.initTransPairs();
  },
};
</script>
